import { createContext } from 'react';

export const ContactListContext = createContext({
  refetch: () => {
    return;
  },
});
